import React from 'react'
import { NavLink } from 'react-router-dom'
import { Option, toRelativeUrl, decodeHTMLEntities, gtmPush } from '../../../helpers'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type Props = {
  location: 'main' | 'footer' | 'copyright'
  hasActiveState: boolean
  before?: JSX.Element
  after?: JSX.Element
  cssClass?: string
  showDescription?: boolean
  onClick?: () => void
  hoveredItem?: WordPress.MenuItem
  onHoverItem?: (menuItemId: WordPress.MenuItem) => void
  onUnhoverItem?: () => void
}


type State = withDataState<WordPress.MenuLocationResponse> & { hover: boolean }

export default class MainNavItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading',
      hover: false,
    }

    // this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this)
    // this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this)
  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then(response => this.setState(s => ({ ...s, kind: 'loaded', data: Option(response.data) })))
      .catch(() => this.setState({ kind: 'error' }))
  }

  // handleOnMouseEnter(item: WordPress.MenuItem) {
  //   this.setState(s => ({...s, hover: true }))
  // }

  // handleOnMouseLeave() {
  //   this.props.onUnhoverItem ? this.props.onUnhoverItem() : null
  //   this.setState(s => ({ ...s, hover: false }))
  // }

  render() {
    let classes = [
      'nav__list',
      this.props.cssClass ? `nav__list--${this.props.cssClass}` : `nav__list--${this.props.location}`,
      this.props.hoveredItem ? 'nav__list--hover' : ''
    ]
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <>
          <ul className={classes.join(' ')}>
            {this.props.before}
            {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
                <li
                  key={`${this.props.location}-${index}`}
                  onMouseEnter={_ => this.props.onHoverItem ? this.props.onHoverItem(menuItem) : null }
                  onFocus={_ => this.props.onHoverItem ? this.props.onHoverItem(menuItem) : null }
                  // onBlur={this.handleOnMouseLeave}
                  // onMouseLeave={this.handleOnMouseLeave}
                  className={`nav__item nav__item--${this.props.location} ${menuItem.classes} ${
                    menuItem.child_items && menuItem.child_items.length > 0 ? 'nav__item--has-children' : ''
                  }`}
                >
                  {this.navItem(menuItem)}
                  {menuItem.child_items && menuItem.child_items.length > 0 ? (
                    <div className="nav nav--submenu submenu--mobile">
                      <ul className="nav__list">
                        {menuItem.child_items.map((menuChild: WordPress.MenuItem) => (
                          <li 
                            key={`${this.props.location}-sub-${menuChild.url}`}
                            className="nav__item typo--2xs">{this.navItem(menuChild)}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ''
                  )}
                </li>
            ))}
            {this.props.after}
          </ul>
        </>
      )
    )
  }

  navItem(menuItem: WordPress.MenuItem) {
    return menuItem.type == 'custom' ? (
      <a
        href={menuItem.url}
        onClick={() => this.props.onClick}
        className={`nav__link nav__link--${this.props.location}`}
        target={menuItem.target}
      >
        {decodeHTMLEntities(menuItem.title)}
        {this.props.showDescription && (
          <>
            <div className="nav__description">{menuItem.description}</div>
            {menuItem.button_label}
          </>
        )}
      </a>
    ) : (
      <NavLink
        to={toRelativeUrl(menuItem.url)}
        onClick={() => this.props.onClick}
        className={`nav__link nav__link--${this.props.location}`}
        activeClassName={this.props.hasActiveState ? 'nav__link--active' : null}
      >{decodeHTMLEntities(menuItem.title)}
        {this.props.showDescription && (
          <>
            <div className="nav__description">{menuItem.description}</div>
            {menuItem.button_label}
          </>
        )}
      </NavLink>
    )
  }
}
